/**
 * CJSUSPENSION brand-hub runtime fixes.
 * Keeps broad brand pages aligned with confirmed workshop support and gives
 * newer brand hubs the same compact navigation hierarchy used by Fox/Vorsprung.
 */
(function () {
  'use strict';

  var path = String(window.location.pathname || '').toLowerCase();

  function normalise(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function isBrandsHubPage() {
    return path === '/pages/brands-we-service';
  }

  function findProductCard(modelName) {
    var target = normalise(modelName);
    var match = null;

    document.querySelectorAll('.cjs-brand-page__product-card').forEach(function (card) {
      if (match) return;
      var heading = card.querySelector('h3');
      if (normalise(heading ? heading.textContent : '') === target) match = card;
    });

    return match;
  }

  function resetBrandsHubLayout() {
    if (!isBrandsHubPage()) return;

    document.querySelectorAll('.cjs-brands-hub__grid').forEach(function (grid) {
      grid.style.alignItems = '';
      grid.style.gridAutoRows = '';
      grid.style.gridAutoFlow = '';
    });

    document.querySelectorAll('.cjs-brands-hub__brand-card, .cjs-brands-hub__information-card').forEach(function (card) {
      card.style.alignSelf = '';
      card.style.height = '';
      card.style.gridRowEnd = '';
    });
  }

  function hidePlaceholderBrandsHubLinks() {
    if (!isBrandsHubPage()) return;

    document.querySelectorAll('.cjs-brands-hub__brand-footer').forEach(function (footer) {
      var link = footer.querySelector('.cjs-brands-hub__card-link');
      if (!link) return;

      var href = String(link.getAttribute('href') || '').trim();
      if (!href || href === '#') footer.hidden = true;
    });
  }

  function configureDvoCard(card) {
    if (!card) return;

    card.dataset.cjsDvoPriority = 'true';

    var headerLink = card.querySelector('.cjs-brands-menu__brand-header a');
    if (headerLink) headerLink.href = '/pages/dvo-suspension-service';

    var brandName = card.querySelector('.cjs-brands-menu__brand-name');
    if (brandName) brandName.textContent = 'DVO';

    var models = card.querySelector('.cjs-brands-menu__models');
    if (models) {
      models.innerHTML = [
        '<li><a href="/pages/dvo-onyx-38">DVO Onyx 38</a></li>',
        '<li><a href="/pages/dvo-onyx-sc">DVO Onyx SC</a></li>',
        '<li><a href="/pages/dvo-onyx-dc">DVO Onyx DC</a></li>',
        '<li><a href="/pages/dvo-diamond">DVO Diamond</a></li>',
        '<li><a href="/pages/dvo-sapphire">DVO Sapphire</a></li>',
        '<li><a href="/pages/dvo-topaz">DVO Topaz</a></li>',
        '<li><a href="/pages/dvo-jade-x">DVO Jade X</a></li>',
        '<li><a href="/pages/dvo-opal">DVO Opal</a></li>'
      ].join('');
    }

    var footerLink = card.querySelector('.cjs-brands-menu__brand-link');
    if (footerLink) {
      footerLink.href = '/pages/dvo-suspension-service';
      footerLink.textContent = 'View DVO service support';
    }
  }

  function replaceCaneCreekWithDvo(menuRoot) {
    var root = menuRoot && menuRoot.querySelectorAll ? menuRoot : document;

    root.querySelectorAll('.cjs-brands-menu__brand').forEach(function (card) {
      if (card.dataset.cjsDvoPriority === 'true') return;

      var brandName = card.querySelector('.cjs-brands-menu__brand-name');
      if (normalise(brandName ? brandName.textContent : '') !== 'cane creek') return;

      configureDvoCard(card);
    });
  }

  function bindBrandsMegaMenuPriority() {
    replaceCaneCreekWithDvo(document);

    if (window.__cjsBrandsMenuPriorityBound || !document.body) return;
    window.__cjsBrandsMenuPriorityBound = true;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) replaceCaneCreekWithDvo(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  var brandDirectories = {
    '/pages/rockshox-suspension-service': {
      title: 'RockShox Models We Service',
      groups: [
        { title: 'Forks', models: [
          ['SID SL', '/pages/rockshox-sid-sl'], ['SID', '/pages/rockshox-sid'],
          ['Pike', '/pages/rockshox-pike'], ['Lyrik', '/pages/rockshox-lyrik'],
          ['ZEB', '/pages/rockshox-zeb'], ['BoXXer', '/pages/rockshox-boxxer'],
          ['Domain', '/pages/rockshox-domain'], ['Yari', '/pages/rockshox-yari'],
          ['Revelation', '/pages/rockshox-revelation'], ['Sektor', '/pages/rockshox-sektor'],
          ['Recon', '/pages/rockshox-recon'], ['Reba', '/pages/rockshox-reba'],
          ['Judy', '/pages/rockshox-judy'], ['35', '/pages/rockshox-35'],
          ['30', '/pages/rockshox-30'], ['Psylo', '/pages/rockshox-psylo'],
          ['Bluto', '/pages/rockshox-bluto'], ['XC-Series', '/pages/rockshox-xc-series'],
          ['RS-1', '/pages/rockshox-rs-1']
        ] },
        { title: 'Air Shocks', models: [
          ['SIDLuxe', '/pages/rockshox-sidluxe'], ['Deluxe', '/pages/rockshox-deluxe'],
          ['Super Deluxe Air', '/pages/rockshox-super-deluxe'], ['Vivid Air', '/pages/rockshox-vivid-air'],
          ['Monarch', '/pages/rockshox-monarch'], ['Monarch Plus', '/pages/rockshox-monarch-plus'],
          ['Brain Shock', '/pages/rockshox-brain-shock']
        ] },
        { title: 'Coil Shocks', models: [
          ['Deluxe Coil', '/pages/rockshox-deluxe-coil'], ['Super Deluxe Coil', '/pages/rockshox-super-deluxe-coil'],
          ['Vivid Coil', '/pages/rockshox-vivid-coil'], ['Kage', '/pages/rockshox-kage']
        ] },
        { title: 'Dropper Posts', models: [['Reverb', '/pages/rockshox-reverb'], ['Reverb AXS', '/pages/rockshox-reverb-axs']] }
      ]
    },
    '/pages/fox-suspension-service': {
      title: 'Fox Models We Service',
      groups: [
        { title: 'Forks', models: [
          ['32', '/pages/fox-32'], ['34', '/pages/fox-34'], ['34 SL', '/pages/fox-34'],
          ['36', '/pages/fox-36'], ['36 SL', '/pages/fox-36'], ['38', '/pages/fox-38'],
          ['40', '/pages/fox-40'], ['Podium', '/pages/fox-podium'], ['831', '/pages/fox-831']
        ] },
        { title: 'Air Shocks', models: [
          ['Float', '/pages/fox-float'], ['Float SL', '/pages/fox-float-sl'],
          ['Float DPS', '/pages/fox-float-dps'], ['Float CTD', '/pages/fox-float-ctd'],
          ['Float RP23 / RP-Series', '/pages/fox-float-rp-series'], ['DPX2', '/pages/fox-dpx2'],
          ['Float X', '/pages/fox-float-x'], ['Float X2', '/pages/fox-float-x2'],
          ['DHX Air 5.0 / 4.0 / 3.0', '/pages/fox-dhx-air-5-0-4-0-3-0'],
          ['Float X CTD', '/pages/fox-float-x-ctd'], ['Specialized GENIE', '/pages/fox-specialized-genie'],
          ['Brain Shock', '/pages/fox-brain-shock']
        ] },
        { title: 'Coil Shocks', models: [
          ['DHX', '/pages/fox-dhx'], ['DHX2', '/pages/fox-dhx2'],
          ['VAN R / RC', '/pages/fox-van-r-rc'], ['DHX RC4 / RC2', '/pages/fox-dhx-rc4-rc2'],
          ['DHX Coil 5.0 / 4.0 / 3.0', '/pages/fox-dhx-coil-5-0-4-0-3-0'], ['Vanilla', '/pages/fox-vanilla']
        ] },
        { title: 'Dropper Posts', models: [['Transfer', '/pages/fox-transfer']] }
      ]
    },
    '/pages/ohlins-suspension-service': {
      title: 'Öhlins Models We Service',
      groups: [
        { title: 'Forks', models: [
          ['RXC34', '/pages/ohlins-rxc34'], ['RXF34', '/pages/ohlins-rxf34'],
          ['RXF36', '/pages/ohlins-rxf36'], ['RXF38', '/pages/ohlins-rxf38'],
          ['DH38', '/pages/ohlins-dh38'], ['RXFDJ', '/pages/ohlins-rxfdj']
        ] },
        { title: 'Air Shocks', models: [
          ['TXC1Air', '/pages/ohlins-txc1air'], ['TXC2Air', '/pages/ohlins-txc2air'],
          ['TTX1Air / TTX1Air m.2', '/pages/ohlins-ttx1air'], ['TTX2Air / TTX2Air m.2', '/pages/ohlins-ttx2air'],
          ['STX22 Air', '/pages/ohlins-stx22-air']
        ] },
        { title: 'Coil Shocks', models: [['TTX22M / TTX22M.2', '/pages/ohlins-ttx22m']] }
      ]
    },
    '/pages/marzocchi-suspension-service': {
      title: 'Marzocchi Models We Service',
      groups: [
        { title: 'Forks', models: [
          ['Bomber Z1', '/pages/marzocchi-bomber-z1'], ['Bomber Z1 Coil', '/pages/marzocchi-bomber-z1'],
          ['Bomber Z2', '/pages/marzocchi-bomber-z2'], ['Bomber DJ', '/pages/marzocchi-bomber-dj'],
          ['Super Z', '/pages/marzocchi-super-z'], ['Bomber Z', '/pages/marzocchi-bomber-z'],
          ['Bomber 58', '/pages/marzocchi-bomber-58'], ['Dirt Jumper', '/pages/marzocchi-dirt-jumper'],
          ['888', '/pages/marzocchi-888'], ['380', '/pages/marzocchi-380'], ['350', '/pages/marzocchi-350'],
          ['66', '/pages/marzocchi-66'], ['55', '/pages/marzocchi-55']
        ] },
        { title: 'Air Shocks', models: [['Bomber Air', '/pages/marzocchi-bomber-air'], ['Bomber Inline', '/pages/marzocchi-bomber-inline']] },
        { title: 'Coil Shocks', models: [['Bomber CR', '/pages/marzocchi-bomber-cr']] }
      ]
    },
    '/pages/dvo-suspension-service': {
      title: 'DVO Models We Service',
      groups: [
        { title: 'Forks', models: [
          ['Onyx 38', '/pages/dvo-onyx-38'], ['Onyx SC', '/pages/dvo-onyx-sc'], ['Onyx DC', '/pages/dvo-onyx-dc'],
          ['Diamond 36', '/pages/dvo-diamond'], ['Diamond 35', '/pages/dvo-diamond'],
          ['Sapphire 34', '/pages/dvo-sapphire'], ['Sapphire 32', '/pages/dvo-sapphire'],
          ['Emerald', '/pages/dvo-emerald'], ['Beryl', '/pages/dvo-beryl']
        ] },
        { title: 'Air Shocks', models: [['Topaz', '/pages/dvo-topaz'], ['Topaz Gen 3', '/pages/dvo-topaz-gen-3'], ['Topaz Prime', '/pages/dvo-topaz-gen-3'], ['Opal', '/pages/dvo-opal']] },
        { title: 'Coil Shocks', models: [['Jade', '/pages/dvo-jade'], ['Jade X', '/pages/dvo-jade-x'], ['Jade X Prime', '/pages/dvo-jade-x']] }
      ]
    },
    '/pages/vorsprung-suspension-service': {
      title: 'Vorsprung Products We Support',
      groups: [
        { title: 'Rear Shocks', models: [['Telum', '/pages/vorsprung-telum']] },
        { title: 'Fork Upgrades', models: [
          ['Smashpot', '/pages/vorsprung-suspension-service#vorsprung-smashpot-installation'],
          ['Secus', '/pages/vorsprung-suspension-service#vorsprung-secus-installation'],
          ['Luftkappe', '/pages/vorsprung-suspension-service#vorsprung-luftkappe-installation'],
          ['Fractive', '/pages/vorsprung-suspension-service#vorsprung-fractive-installation']
        ] },
        { title: 'Shock Upgrades', models: [['Tractive', '/pages/vorsprung-suspension-service#vorsprung-tractive-tuning']] }
      ]
    },

    '/pages/ext-suspension-service': {
      compact: true,
      eyebrow: 'Supported product families',
      title: 'EXT Models We Service',
      intro: 'The confirmed EXT families below have dedicated service pages. Exact generation and parts support are checked before work begins.',
      groups: [
        { title: 'Forks', models: [['ERA Family', '/pages/ext-era']] },
        { title: 'Rear Shocks', models: [['Storia Family', '/pages/ext-storia']] }
      ]
    },
    '/pages/bos-suspension-service': {
      compact: true,
      eyebrow: 'Supported product families',
      title: 'BOS Models We Service',
      intro: 'Only the BOS families confirmed in this build are shown here. Select a family to open its dedicated service page.',
      groups: [
        { title: 'Forks', models: [['Deville 34', '/pages/bos-deville-34'], ['Idylle 36', '/pages/bos-idylle-36']] },
        { title: 'Rear Shocks', models: [['Kirk Family', '/pages/bos-kirk'], ['Stoy Family', '/pages/bos-stoy'], ['Void Family', '/pages/bos-void'], ['Syors Family', '/pages/bos-syors']] }
      ]
    },
    '/pages/x-fusion-suspension-service': {
      compact: true,
      eyebrow: 'Supported model',
      title: 'X-Fusion Model We Service',
      intro: 'CJSUSPENSION currently lists confirmed workshop support for the X-Fusion O2 Pro. Exact generation and parts support are checked before work begins.',
      groups: [{ title: 'Rear Shocks', models: [['O2 Pro', '/pages/x-fusion-o2-pro']] }]
    },
    '/pages/fast-suspension-service': {
      compact: true,
      eyebrow: 'Confirmed product families',
      title: 'FAST Products We Service',
      intro: 'Book the suspension service first. CJSUSPENSION will confirm the exact FAST product, service requirements and compatible stocked part for the workshop job.',
      groups: [
        { title: 'Rear Shocks', models: [['Fenix Family', '/pages/fast-fenix'], ['Ride Family', '/pages/fast-ride'], ['Holy Grail', '/pages/fast-holy-grail']] },
        { title: 'Fork Upgrades', models: [['SC5 Fork Cartridge', '/pages/fast-sc5-cartridge'], ['DC3 RockShox Fork Upgrade', '/pages/fast-dc3-rockshox']] }
      ]
    },
    '/pages/manitou-suspension-service': {
      compact: true,
      eyebrow: 'Supported product families',
      title: 'Manitou Models We Service',
      intro: 'CJSUSPENSION currently lists confirmed workshop support for the Manitou Mezzer and Dorado families below.',
      groups: [{ title: 'Forks', models: [['Mezzer Family', '/pages/manitou-mezzer'], ['Dorado Family', '/pages/manitou-dorado']] }]
    },
    '/pages/ks-dropper-service': {
      compact: true,
      eyebrow: 'Supported family',
      title: 'KS Dropper Post Support',
      intro: 'KS servicing is grouped into one consolidated family page so the workshop journey stays clear.',
      groups: [{ title: 'Dropper Posts', models: [['KS Dropper Post Family', '/pages/ks-dropper-post']] }]
    },
    '/pages/specialized-dropper-service': {
      compact: true,
      eyebrow: 'Supported family',
      title: 'Specialized Command Post Support',
      intro: 'Supported Command Post variants are grouped into one family page for clear service information.',
      groups: [{ title: 'Dropper Posts', models: [['Command Post Family', '/pages/specialized-command-post']] }]
    },
    '/pages/bikeyoke-dropper-service': {
      compact: true,
      eyebrow: 'Supported family',
      title: 'BikeYoke Dropper Post Support',
      intro: 'Supported REVIVE and DIVINE variants are grouped into one family page for clear service information.',
      groups: [{ title: 'Dropper Posts', models: [['BikeYoke Dropper Post Family', '/pages/bikeyoke-dropper-post']] }]
    },
    '/pages/race-face-dropper-service': {
      compact: true,
      eyebrow: 'Supported family',
      title: 'Race Face Dropper Post Support',
      intro: 'Supported Race Face dropper posts are grouped into one family page for clear service information.',
      groups: [{ title: 'Dropper Posts', models: [['Race Face Dropper Post Family', '/pages/race-face-dropper-post']] }]
    }
  };

  function addModelDirectoryStyles() {
    if (document.getElementById('cjs-brand-model-directory-styles')) return;

    var style = document.createElement('style');
    style.id = 'cjs-brand-model-directory-styles';
    style.textContent =
      '.cjs-brand-model-directory{margin:0 0 46px;padding:28px;border:1px solid var(--cjs-border,#e6e2dd);border-radius:var(--cjs-radius,10px);background:var(--cjs-card-background,#fff);box-shadow:0 10px 28px rgba(17,17,17,.035)}' +
      '.cjs-brand-model-directory__header{display:grid;grid-template-columns:minmax(0,1fr) minmax(260px,.8fr);gap:28px;align-items:end;margin-bottom:24px;padding-bottom:22px;border-bottom:1px solid var(--cjs-border,#e6e2dd)}' +
      '.cjs-brand-model-directory__eyebrow{margin:0 0 7px;color:var(--cjs-accent,#a8323a);font-size:11px;font-weight:800;letter-spacing:.13em;text-transform:uppercase}' +
      '.cjs-brand-model-directory h2{margin:0;color:var(--cjs-text,#111);font-size:clamp(27px,3vw,38px);font-weight:800;line-height:1.06;letter-spacing:-.03em}' +
      '.cjs-brand-model-directory__intro{margin:0;color:var(--cjs-muted,#606060);font-size:14px;line-height:1.65}' +
      '.cjs-brand-model-directory__groups{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:16px}' +
      '.cjs-brand-model-directory--compact .cjs-brand-model-directory__groups{grid-template-columns:repeat(auto-fit,minmax(250px,1fr))}' +
      '.cjs-brand-model-directory__group{padding:20px;border:1px solid var(--cjs-border,#e6e2dd);border-radius:8px;background:var(--cjs-alt-background,#f1eeea)}' +
      '.cjs-brand-model-directory__group h3{margin:0 0 13px;color:var(--cjs-text,#111);font-size:13px;font-weight:800;letter-spacing:.08em;text-transform:uppercase}' +
      '.cjs-brand-model-directory__models{display:flex;flex-wrap:wrap;gap:8px;margin:0;padding:0;list-style:none}' +
      '.cjs-brand-model-directory__models li{margin:0;padding:0}' +
      '.cjs-brand-model-directory__models a,.cjs-brand-model-directory__models span{display:inline-flex;align-items:center;min-height:34px;padding:7px 11px;border:1px solid var(--cjs-border,#e6e2dd);border-radius:999px;color:var(--cjs-text,#111);background:#fff;font-size:12px;font-weight:750;line-height:1.2;text-decoration:none}' +
      '.cjs-brand-model-directory__models a:hover{color:var(--cjs-accent,#a8323a);border-color:var(--cjs-accent,#a8323a);background:rgba(168,50,58,.05)}' +
      '.cjs-brand-model-directory__models span{opacity:.72}' +
      '.cjs-brand-page[data-cjs-compact-brand-hub="true"] .cjs-brand-page__products{display:none!important}' +
      '.cjs-brand-page[data-cjs-compact-brand-hub="true"] .cjs-brand-page__service-grid[data-cjs-single-tool="true"]{grid-template-columns:minmax(0,360px)!important}' +
      '@media(max-width:749px){.cjs-brand-model-directory{padding:20px}.cjs-brand-model-directory__header{grid-template-columns:1fr;gap:12px}.cjs-brand-model-directory__groups{grid-template-columns:1fr}.cjs-brand-page[data-cjs-compact-brand-hub="true"] .cjs-brand-page__service-grid[data-cjs-single-tool="true"]{grid-template-columns:1fr!important}}';

    document.head.appendChild(style);
  }

  function enforceCompactBrandHub(config) {
    if (!config || !config.compact) return;

    addModelDirectoryStyles();

    var pageRoot = document.querySelector('.cjs-brand-page');
    if (pageRoot) pageRoot.setAttribute('data-cjs-compact-brand-hub', 'true');

    var products = document.querySelector('.cjs-brand-page__products');
    if (products) {
      products.hidden = true;
      products.setAttribute('aria-hidden', 'true');
      products.style.setProperty('display', 'none', 'important');
    }
  }

  function injectBrandModelDirectory() {
    var config = brandDirectories[path];
    if (!config) return;

    var existing = document.querySelector('[data-cjs-brand-model-directory]');
    if (existing) {
      enforceCompactBrandHub(config);
      return;
    }

    var products = document.querySelector('.cjs-brand-page__products');
    if (!products || !products.parentNode) return;

    addModelDirectoryStyles();

    var directory = document.createElement('section');
    directory.className = 'cjs-brand-model-directory' + (config.compact ? ' cjs-brand-model-directory--compact' : '');
    directory.setAttribute('data-cjs-brand-model-directory', '');

    var header = document.createElement('div');
    header.className = 'cjs-brand-model-directory__header';

    var headingWrap = document.createElement('div');
    var eyebrow = document.createElement('p');
    eyebrow.className = 'cjs-brand-model-directory__eyebrow';
    eyebrow.textContent = config.eyebrow || 'Complete workshop support';

    var heading = document.createElement('h2');
    heading.textContent = config.title;

    headingWrap.appendChild(eyebrow);
    headingWrap.appendChild(heading);

    var intro = document.createElement('p');
    intro.className = 'cjs-brand-model-directory__intro';
    intro.textContent = config.intro || 'Select a model or product to open its dedicated service/support page.';

    header.appendChild(headingWrap);
    header.appendChild(intro);
    directory.appendChild(header);

    var groups = document.createElement('div');
    groups.className = 'cjs-brand-model-directory__groups';

    config.groups.forEach(function (groupConfig) {
      var group = document.createElement('div');
      group.className = 'cjs-brand-model-directory__group';

      var groupHeading = document.createElement('h3');
      groupHeading.textContent = groupConfig.title;
      group.appendChild(groupHeading);

      var list = document.createElement('ul');
      list.className = 'cjs-brand-model-directory__models';
      list.setAttribute('role', 'list');

      groupConfig.models.forEach(function (model) {
        var item = document.createElement('li');
        var element = document.createElement(model[1] ? 'a' : 'span');

        if (model[1]) {
          element.href = model[1];
          element.setAttribute('data-cjs-model-directory-link', '');
        }

        element.textContent = model[0];
        item.appendChild(element);
        list.appendChild(item);
      });

      group.appendChild(list);
      groups.appendChild(group);
    });

    directory.appendChild(groups);
    products.parentNode.insertBefore(directory, products);

    if (config.compact) {
      enforceCompactBrandHub(config);
      return;
    }

    var productHeading = products.querySelector('.cjs-brand-page__section-header h2');
    if (productHeading && /^common\s/i.test(productHeading.textContent.trim())) {
      productHeading.textContent = productHeading.textContent.trim().replace(/^Common\s+/i, 'Featured ');
    }
  }

  function fixDropperOnlyTools() {
    var dropperBrands = {
      '/pages/ks-dropper-service': 'KS',
      '/pages/specialized-dropper-service': 'Specialized',
      '/pages/bikeyoke-dropper-service': 'BikeYoke',
      '/pages/race-face-dropper-service': 'Race Face'
    };

    if (!dropperBrands[path]) return;

    var services = document.querySelector('.cjs-brand-page__services');
    if (!services) return;

    var grid = services.querySelector('.cjs-brand-page__service-grid');
    if (!grid) return;

    Array.prototype.slice.call(grid.querySelectorAll('.cjs-brand-page__service-card')).forEach(function (card) {
      var heading = card.querySelector('h3');
      if (normalise(heading ? heading.textContent : '') !== 'suspension hour meter') card.remove();
    });

    grid.setAttribute('data-cjs-single-tool', 'true');

    var heading = services.querySelector('.cjs-brand-page__section-header h2');
    if (heading) heading.textContent = dropperBrands[path] + ' Workshop Services';

    var copy = services.querySelector('.cjs-brand-page__section-copy');
    if (copy) {
      var paragraph = copy.querySelector('p') || copy;
      paragraph.textContent = 'Track service timing for your dropper post before booking your next workshop service.';
    }
  }

  function fixFastServiceLanguage() {
    if (path !== '/pages/fast-suspension-service') return;

    document.querySelectorAll('.cjs-brand-performance-upgrades__card').forEach(function (card) {
      card.querySelectorAll('a').forEach(function (link) {
        if (/book fast upgrade/i.test(link.textContent || '')) {
          var label = link.querySelector('span:first-child');
          if (label) label.textContent = 'Book FAST Service';
          else link.textContent = 'Book FAST Service';
          link.href = '/pages/book-a-suspension-service';
        }
      });
    });
  }

  function fixRockShoxBushingClaims() {
    if (path !== '/pages/rockshox-suspension-service') return;

    var zebCard = findProductCard('RockShox Zeb');
    if (zebCard) {
      zebCard.querySelectorAll('.cjs-brand-page__product-services li').forEach(function (item) {
        if (normalise(item.textContent) === 'lower-leg bushing replacement') item.remove();
      });
    }

    var boxxerCard = findProductCard('RockShox Boxxer');
    if (boxxerCard) {
      boxxerCard.querySelectorAll('.cjs-brand-page__product-services li').forEach(function (item) {
        if (normalise(item.textContent) === 'bushing replacement and sizing') {
          item.textContent = '35mm BoXXer bushing replacement and sizing';
        }
      });
    }
  }

  function fixFoxHubClaims() {
    if (path !== '/pages/fox-suspension-service') return;

    var floatX2Card = findProductCard('Fox Float X2');
    if (floatX2Card) {
      var list = floatX2Card.querySelector('.cjs-brand-page__product-services ul');
      if (list) {
        var has25hr = false;
        list.querySelectorAll('li').forEach(function (item) {
          if (normalise(item.textContent).indexOf('25hr') === 0) has25hr = true;
        });

        if (!has25hr) {
          var item = document.createElement('li');
          item.textContent = '25hr Air Sleeve Clean & Grease';
          list.insertBefore(item, list.firstChild);
        }
      }

      var note = floatX2Card.querySelector('.cjs-brand-page__product-note');
      if (note) {
        note.textContent = 'Fox Float X2 uses the CJSUSPENSION 25hr and 100hr service options. A 50hr air-sleeve service is not offered for Float X2. Provide the production year, eye-to-eye length, stroke and bike model when booking.';
      }
    }

    var podiumCard = findProductCard('Fox Podium');
    if (podiumCard) {
      podiumCard.querySelectorAll('.cjs-brand-page__product-services li').forEach(function (item) {
        var label = normalise(item.textContent);
        if (label === '25hr lower leg & foam ring service') item.textContent = '25hr Lower Tube & Foam Ring Service';
        else if (label === '50hr lower leg service') item.textContent = '50hr Lower Tube Service';
      });
    }
  }

  function run() {
    path = String(window.location.pathname || '').toLowerCase();
    resetBrandsHubLayout();
    hidePlaceholderBrandsHubLinks();
    bindBrandsMegaMenuPriority();
    injectBrandModelDirectory();
    enforceCompactBrandHub(brandDirectories[path]);
    fixDropperOnlyTools();
    fixFastServiceLanguage();
    fixRockShoxBushingClaims();
    fixFoxHubClaims();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.setTimeout(run, 80);
  window.setTimeout(run, 350);
  window.setTimeout(run, 1200);

  document.addEventListener('shopify:section:load', function () {
    window.requestAnimationFrame(run);
  });

  if (document.body) {
    var compactObserver = new MutationObserver(function () {
      var config = brandDirectories[String(window.location.pathname || '').toLowerCase()];
      if (config && config.compact) enforceCompactBrandHub(config);
    });
    compactObserver.observe(document.body, { childList: true, subtree: true });
  }
})();